const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
const wrap = (n, max) => (n % max + max) % max;

function loadImages(frames, images, onError) {
    const list = [];

    for (let index = 0; index < frames; index++) {
        const src = images[index];
        const img = new Image();
        img.decoding = 'async';
        img.loading = 'eager';
        img.onerror = function (test) {
            onError(`Échec chargement: ${src}`)
        };
        img.src = src;
        list.push(img);
    }

    return list;
}

export default class Viewer360 {
  constructor(cfg) {
    this.cfg = cfg;
    this.$root = document.querySelector(cfg.container);
    this.$img = this.$root.querySelector('.maier-viewer-360-image');
    this.$loader = this.$root.querySelector('.maier-viewer-360-ui-loader');
    this.$btnLeft = this.$root.querySelector('.maier-viewer-360-controls-button-left');
    this.$btnRight = this.$root.querySelector('.maier-viewer-360-controls-button-right');
    this.$btnPlay = this.$root.querySelector('.maier-viewer-360-controls-button-play');

    this.frames = [];
    this.index = 0;
    this.dragging = false;
    this.startX = 0;
    this.lastX = 0;
    this.accum = 0;
    this.raf = null;
    this.playTimer = null;

    this.init();
  }

  init() {
    this.error = 0;
    this.frames = loadImages(
        this.cfg.frames,
        this.cfg.images,
        (err) => {
            console.error(err);

            this.error = 1
            this.$loader.innerHTML = 'Impossible de charger les images.';

            return;
        }
    );

    if (1 === this.error) {
        return;
    }

    this.setFrame(0);
    this.$img.style.opacity = 1;
    this.$loader.style.display = 'none';

    this.bindEvents();

    if (this.cfg.autoplay) this.play();
  }

  bindEvents() {
    this.$root.addEventListener('pointerdown', (e) => this.onPointerDown(e));
    window.addEventListener('pointermove', (e) => this.onPointerMove(e));
    window.addEventListener('pointerup', () => this.onPointerUp());
    window.addEventListener('pointercancel', () => this.onPointerUp());

    this.$root.addEventListener('wheel', (e) => {
      e.preventDefault();
      const step = Math.sign(e.deltaY) * this.cfg.wheelStep;
      this.step(step);
    }, { passive: false });

    this.$root.tabIndex = 0;
    this.$root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.step(-1);
      if (e.key === 'ArrowRight') this.step(1);
      if (e.key.toLowerCase() === ' ') this.togglePlay();
    });

    this.$btnLeft.addEventListener('click', () => this.step(-1));
    this.$btnRight.addEventListener('click', () => this.step(1));
    this.$btnPlay.addEventListener('click', () => this.togglePlay());
  }

  onPointerDown(e) {
    this.dragging = true;
    this.$root.classList.remove('grab');
    this.$root.classList.add('grabbing');
    this.startX = this.lastX = e.clientX;
    this.accum = 0;
    this.stop();
  }

  onPointerMove(e) {
    if (!this.dragging) return;
    const dx = e.clientX - this.lastX;
    this.lastX = e.clientX;
    const dir = this.cfg.invertDrag ? -1 : 1;
    this.accum += dx * dir;

    const threshold = this.cfg.dragSpeed;
    let steps = 0;
    while (Math.abs(this.accum) >= threshold) {
      steps += Math.sign(this.accum);
      this.accum -= threshold * Math.sign(this.accum);
    }
    if (steps !== 0) this.step(steps);
  }

  onPointerUp() {
    if (!this.dragging) return;
    this.dragging = false;
    this.$root.classList.remove('grabbing');
    this.$root.classList.add('grab');
  }

  setFrame(i) {
    this.index = this.cfg.loop ? wrap(i, this.frames.length) : clamp(i, 0, this.frames.length - 1);
    const src = this.frames[this.index].src;
    if (this.$img.src !== src) this.$img.src = src;
  }

  step(n) {
    this.setFrame(this.index + n);
  }

  play() {
    const interval = 1000 / this.cfg.autoplayFPS;
    if (this.playTimer) clearInterval(this.playTimer);
    this.$btnPlay.textContent = '⏸';
    this.playTimer = setInterval(() => this.step(1), interval);
  }

  stop() {
    if (this.playTimer) clearInterval(this.playTimer);
    this.playTimer = null;
    this.$btnPlay.textContent = '▶';
  }

  togglePlay() { this.playTimer ? this.stop() : this.play(); }
}